import appLogger from '@/utils/logger';
import { IGetKeywordIdeasBody, IGetKeywordIdeasRes } from '@/types/offers';
import type { IPageLinkSearchResult } from '@/types/page-cta';
import { apiInstance } from '@/utils';

/**
 * Update an offer.
 *
 * @param {number} offerId The ID of the offer to update.
 * @param {string} offer The updated offer string.
 * @param {string} callToAction The updated call to action.
 * @returns The response data or null in case of an error.
 */
export const updateOffer = async (
  offerId: number,
  offer: string,
  callToAction: string,
): Promise<any> => {
  try {
    const response = await apiInstance.put(`/private/offers/${offerId}`, {
      offer,
      callToAction,
    });
    return response.data;
  } catch (error) {
    appLogger.error('Failed to update offer:', { data: error });
    return null;
  }
};

export const searchPageLink = async (query: string): Promise<{ data: IPageLinkSearchResult[] }> => {
  const response = await apiInstance.get('/private/links/search-link', {
    params: {
      searchText: query,
    },
  });

  return response.data;
};

const getKeywordIdeas = async (data: IGetKeywordIdeasBody): Promise<IGetKeywordIdeasRes> => {
  const response = await apiInstance.post('/private/offers/keyword-ideas', data);

  return response.data;
};
